import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * Block service class containing all methods to retrieve blocks
 */
class BlockService {
  static getBlocks(limit = 10, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.BLOCKS}?pageSize=${limit}&page=${page}`)
  }

  static getBlock(id) {
    return ApiHelper.fetch(`${API.URL + API.BLOCKS}/${id}`)
  }

  static getBlockByName(name) {
    return ApiHelper.fetch(`${API.URL + API.BLOCKS}/by-name/${name}`)
  }

  static addBlock(block) {
    return ApiHelper.fetch(`${API.URL + API.BLOCKS}`, {
      method: 'POST',
      body: JSON.stringify({
        block
      })
    })
  }

  static updateBlock(block) {
    if (typeof block._id === 'undefined') {
      return this.addBlock(block)
    }

    return ApiHelper.fetch(`${API.URL + API.BLOCKS}/${block['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        block
      })
    })
  }

  static deleteBlock(id) {
    return ApiHelper.fetch(`${API.URL + API.BLOCKS}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default BlockService
